var v = Object.defineProperty;

var e = function e(d, p) {
  for (var n in p) {
    v(d, n, {
      get: p[n],
      enumerable: !0
    });
  }
};

var l = {};
e(l, {
  $scale: function $scale() {
    return r;
  },
  $semantic: function $semantic() {
    return t;
  },
  $static: function $static() {
    return c;
  }
});
var r = {};
e(r, {
  color: function color() {
    return o;
  }
});
var o = {};
e(o, {
  blue100: function blue100() {
    return S;
  },
  blue200: function blue200() {
    return T;
  },
  blue300: function blue300() {
    return Y;
  },
  blue400: function blue400() {
    return F;
  },
  blue50: function blue50() {
    return R;
  },
  blue500: function blue500() {
    return j;
  },
  blue600: function blue600() {
    return q;
  },
  blue700: function blue700() {
    return z;
  },
  blue800: function blue800() {
    return E;
  },
  blue900: function blue900() {
    return I;
  },
  blue950: function blue950() {
    return J;
  },
  blueAlpha100: function blueAlpha100() {
    return eo;
  },
  blueAlpha200: function blueAlpha200() {
    return oo;
  },
  blueAlpha50: function blueAlpha50() {
    return _e;
  },
  carrot100: function carrot100() {
    return f;
  },
  carrot200: function carrot200() {
    return P;
  },
  carrot300: function carrot300() {
    return O;
  },
  carrot400: function carrot400() {
    return B;
  },
  carrot50: function carrot50() {
    return L;
  },
  carrot500: function carrot500() {
    return G;
  },
  carrot600: function carrot600() {
    return C;
  },
  carrot700: function carrot700() {
    return D;
  },
  carrot800: function carrot800() {
    return H;
  },
  carrot900: function carrot900() {
    return W;
  },
  carrot950: function carrot950() {
    return $;
  },
  carrotAlpha100: function carrotAlpha100() {
    return Xe;
  },
  carrotAlpha200: function carrotAlpha200() {
    return Ze;
  },
  carrotAlpha50: function carrotAlpha50() {
    return Ve;
  },
  gray00: function gray00() {
    return x;
  },
  gray100: function gray100() {
    return y;
  },
  gray200: function gray200() {
    return g;
  },
  gray300: function gray300() {
    return m;
  },
  gray400: function gray400() {
    return w;
  },
  gray50: function gray50() {
    return i;
  },
  gray500: function gray500() {
    return u;
  },
  gray600: function gray600() {
    return h;
  },
  gray700: function gray700() {
    return b;
  },
  gray800: function gray800() {
    return k;
  },
  gray900: function gray900() {
    return A;
  },
  grayAlpha100: function grayAlpha100() {
    return Ne;
  },
  grayAlpha200: function grayAlpha200() {
    return Qe;
  },
  grayAlpha50: function grayAlpha50() {
    return Me;
  },
  grayAlpha500: function grayAlpha500() {
    return Ue;
  },
  green100: function green100() {
    return ae;
  },
  green200: function green200() {
    return ce;
  },
  green300: function green300() {
    return se;
  },
  green400: function green400() {
    return te;
  },
  green50: function green50() {
    return re;
  },
  green500: function green500() {
    return le;
  },
  green600: function green600() {
    return pe;
  },
  green700: function green700() {
    return ne;
  },
  green800: function green800() {
    return de;
  },
  green900: function green900() {
    return ve;
  },
  green950: function green950() {
    return xe;
  },
  greenAlpha100: function greenAlpha100() {
    return no;
  },
  greenAlpha200: function greenAlpha200() {
    return vo;
  },
  greenAlpha50: function greenAlpha50() {
    return po;
  },
  pink100: function pink100() {
    return Pe;
  },
  pink200: function pink200() {
    return Oe;
  },
  pink300: function pink300() {
    return Be;
  },
  pink400: function pink400() {
    return Ge;
  },
  pink50: function pink50() {
    return fe;
  },
  pink500: function pink500() {
    return Ce;
  },
  pink600: function pink600() {
    return De;
  },
  pink700: function pink700() {
    return He;
  },
  pink800: function pink800() {
    return We;
  },
  pink900: function pink900() {
    return $e;
  },
  pink950: function pink950() {
    return Re;
  },
  purple100: function purple100() {
    return Te;
  },
  purple200: function purple200() {
    return Ye;
  },
  purple300: function purple300() {
    return Fe;
  },
  purple400: function purple400() {
    return je;
  },
  purple50: function purple50() {
    return Se;
  },
  purple500: function purple500() {
    return qe;
  },
  purple600: function purple600() {
    return ze;
  },
  purple700: function purple700() {
    return Ee;
  },
  purple800: function purple800() {
    return Ie;
  },
  purple900: function purple900() {
    return Je;
  },
  purple950: function purple950() {
    return Ke;
  },
  red100: function red100() {
    return M;
  },
  red200: function red200() {
    return N;
  },
  red300: function red300() {
    return Q;
  },
  red400: function red400() {
    return U;
  },
  red50: function red50() {
    return K;
  },
  red500: function red500() {
    return V;
  },
  red600: function red600() {
    return X;
  },
  red700: function red700() {
    return Z;
  },
  red800: function red800() {
    return _;
  },
  red900: function red900() {
    return ee;
  },
  red950: function red950() {
    return oe;
  },
  redAlpha100: function redAlpha100() {
    return ao;
  },
  redAlpha200: function redAlpha200() {
    return co;
  },
  redAlpha50: function redAlpha50() {
    return ro;
  },
  yellow100: function yellow100() {
    return ye;
  },
  yellow200: function yellow200() {
    return ge;
  },
  yellow300: function yellow300() {
    return me;
  },
  yellow400: function yellow400() {
    return we;
  },
  yellow50: function yellow50() {
    return ie;
  },
  yellow500: function yellow500() {
    return ue;
  },
  yellow600: function yellow600() {
    return he;
  },
  yellow700: function yellow700() {
    return be;
  },
  yellow800: function yellow800() {
    return ke;
  },
  yellow900: function yellow900() {
    return Ae;
  },
  yellow950: function yellow950() {
    return Le;
  },
  yellowAlpha100: function yellowAlpha100() {
    return to;
  },
  yellowAlpha200: function yellowAlpha200() {
    return lo;
  },
  yellowAlpha50: function yellowAlpha50() {
    return so;
  }
});
var x = "var(--seed-scale-color-gray-00)",
    i = "var(--seed-scale-color-gray-50)",
    y = "var(--seed-scale-color-gray-100)",
    g = "var(--seed-scale-color-gray-200)",
    m = "var(--seed-scale-color-gray-300)",
    w = "var(--seed-scale-color-gray-400)",
    u = "var(--seed-scale-color-gray-500)",
    h = "var(--seed-scale-color-gray-600)",
    b = "var(--seed-scale-color-gray-700)",
    k = "var(--seed-scale-color-gray-800)",
    A = "var(--seed-scale-color-gray-900)",
    L = "var(--seed-scale-color-carrot-50)",
    f = "var(--seed-scale-color-carrot-100)",
    P = "var(--seed-scale-color-carrot-200)",
    O = "var(--seed-scale-color-carrot-300)",
    B = "var(--seed-scale-color-carrot-400)",
    G = "var(--seed-scale-color-carrot-500)",
    C = "var(--seed-scale-color-carrot-600)",
    D = "var(--seed-scale-color-carrot-700)",
    H = "var(--seed-scale-color-carrot-800)",
    W = "var(--seed-scale-color-carrot-900)",
    $ = "var(--seed-scale-color-carrot-950)",
    R = "var(--seed-scale-color-blue-50)",
    S = "var(--seed-scale-color-blue-100)",
    T = "var(--seed-scale-color-blue-200)",
    Y = "var(--seed-scale-color-blue-300)",
    F = "var(--seed-scale-color-blue-400)",
    j = "var(--seed-scale-color-blue-500)",
    q = "var(--seed-scale-color-blue-600)",
    z = "var(--seed-scale-color-blue-700)",
    E = "var(--seed-scale-color-blue-800)",
    I = "var(--seed-scale-color-blue-900)",
    J = "var(--seed-scale-color-blue-950)",
    K = "var(--seed-scale-color-red-50)",
    M = "var(--seed-scale-color-red-100)",
    N = "var(--seed-scale-color-red-200)",
    Q = "var(--seed-scale-color-red-300)",
    U = "var(--seed-scale-color-red-400)",
    V = "var(--seed-scale-color-red-500)",
    X = "var(--seed-scale-color-red-600)",
    Z = "var(--seed-scale-color-red-700)",
    _ = "var(--seed-scale-color-red-800)",
    ee = "var(--seed-scale-color-red-900)",
    oe = "var(--seed-scale-color-red-950)",
    re = "var(--seed-scale-color-green-50)",
    ae = "var(--seed-scale-color-green-100)",
    ce = "var(--seed-scale-color-green-200)",
    se = "var(--seed-scale-color-green-300)",
    te = "var(--seed-scale-color-green-400)",
    le = "var(--seed-scale-color-green-500)",
    pe = "var(--seed-scale-color-green-600)",
    ne = "var(--seed-scale-color-green-700)",
    de = "var(--seed-scale-color-green-800)",
    ve = "var(--seed-scale-color-green-900)",
    xe = "var(--seed-scale-color-green-950)",
    ie = "var(--seed-scale-color-yellow-50)",
    ye = "var(--seed-scale-color-yellow-100)",
    ge = "var(--seed-scale-color-yellow-200)",
    me = "var(--seed-scale-color-yellow-300)",
    we = "var(--seed-scale-color-yellow-400)",
    ue = "var(--seed-scale-color-yellow-500)",
    he = "var(--seed-scale-color-yellow-600)",
    be = "var(--seed-scale-color-yellow-700)",
    ke = "var(--seed-scale-color-yellow-800)",
    Ae = "var(--seed-scale-color-yellow-900)",
    Le = "var(--seed-scale-color-yellow-950)",
    fe = "var(--seed-scale-color-pink-50)",
    Pe = "var(--seed-scale-color-pink-100)",
    Oe = "var(--seed-scale-color-pink-200)",
    Be = "var(--seed-scale-color-pink-300)",
    Ge = "var(--seed-scale-color-pink-400)",
    Ce = "var(--seed-scale-color-pink-500)",
    De = "var(--seed-scale-color-pink-600)",
    He = "var(--seed-scale-color-pink-700)",
    We = "var(--seed-scale-color-pink-800)",
    $e = "var(--seed-scale-color-pink-900)",
    Re = "var(--seed-scale-color-pink-950)",
    Se = "var(--seed-scale-color-purple-50)",
    Te = "var(--seed-scale-color-purple-100)",
    Ye = "var(--seed-scale-color-purple-200)",
    Fe = "var(--seed-scale-color-purple-300)",
    je = "var(--seed-scale-color-purple-400)",
    qe = "var(--seed-scale-color-purple-500)",
    ze = "var(--seed-scale-color-purple-600)",
    Ee = "var(--seed-scale-color-purple-700)",
    Ie = "var(--seed-scale-color-purple-800)",
    Je = "var(--seed-scale-color-purple-900)",
    Ke = "var(--seed-scale-color-purple-950)",
    Me = "var(--seed-scale-color-gray-alpha-50)",
    Ne = "var(--seed-scale-color-gray-alpha-100)",
    Qe = "var(--seed-scale-color-gray-alpha-200)",
    Ue = "var(--seed-scale-color-gray-alpha-500)",
    Ve = "var(--seed-scale-color-carrot-alpha-50)",
    Xe = "var(--seed-scale-color-carrot-alpha-100)",
    Ze = "var(--seed-scale-color-carrot-alpha-200)",
    _e = "var(--seed-scale-color-blue-alpha-50)",
    eo = "var(--seed-scale-color-blue-alpha-100)",
    oo = "var(--seed-scale-color-blue-alpha-200)",
    ro = "var(--seed-scale-color-red-alpha-50)",
    ao = "var(--seed-scale-color-red-alpha-100)",
    co = "var(--seed-scale-color-red-alpha-200)",
    so = "var(--seed-scale-color-yellow-alpha-50)",
    to = "var(--seed-scale-color-yellow-alpha-100)",
    lo = "var(--seed-scale-color-yellow-alpha-200)",
    po = "var(--seed-scale-color-green-alpha-50)",
    no = "var(--seed-scale-color-green-alpha-100)",
    vo = "var(--seed-scale-color-green-alpha-200)";
var c = {};
e(c, {
  color: function color() {
    return a;
  }
});
var a = {};
e(a, {
  staticBlack: function staticBlack() {
    return xo;
  },
  staticBlackAlpha200: function staticBlackAlpha200() {
    return Po;
  },
  staticBlackAlpha500: function staticBlackAlpha500() {
    return Oo;
  },
  staticBlue50: function staticBlue50() {
    return Lo;
  },
  staticBlue800: function staticBlue800() {
    return fo;
  },
  staticCarrot50: function staticCarrot50() {
    return go;
  },
  staticCarrot800: function staticCarrot800() {
    return mo;
  },
  staticGray900: function staticGray900() {
    return yo;
  },
  staticGreen50: function staticGreen50() {
    return wo;
  },
  staticGreen800: function staticGreen800() {
    return uo;
  },
  staticRed50: function staticRed50() {
    return ko;
  },
  staticRed800: function staticRed800() {
    return Ao;
  },
  staticWhite: function staticWhite() {
    return io;
  },
  staticWhiteAlpha200: function staticWhiteAlpha200() {
    return Go;
  },
  staticWhiteAlpha50: function staticWhiteAlpha50() {
    return Bo;
  },
  staticYellow50: function staticYellow50() {
    return ho;
  },
  staticYellow800: function staticYellow800() {
    return bo;
  }
});
var xo = "var(--seed-static-color-static-black)",
    io = "var(--seed-static-color-static-white)",
    yo = "var(--seed-static-color-static-gray-900)",
    go = "var(--seed-static-color-static-carrot-50)",
    mo = "var(--seed-static-color-static-carrot-800)",
    wo = "var(--seed-static-color-static-green-50)",
    uo = "var(--seed-static-color-static-green-800)",
    ho = "var(--seed-static-color-static-yellow-50)",
    bo = "var(--seed-static-color-static-yellow-800)",
    ko = "var(--seed-static-color-static-red-50)",
    Ao = "var(--seed-static-color-static-red-800)",
    Lo = "var(--seed-static-color-static-blue-50)",
    fo = "var(--seed-static-color-static-blue-800)",
    Po = "var(--seed-static-color-static-black-alpha-200)",
    Oo = "var(--seed-static-color-static-black-alpha-500)",
    Bo = "var(--seed-static-color-static-white-alpha-50)",
    Go = "var(--seed-static-color-static-white-alpha-200)";
var t = {};
e(t, {
  color: function color() {
    return s;
  }
});
var s = {};
e(s, {
  accent: function accent() {
    return ir;
  },
  danger: function danger() {
    return Eo;
  },
  dangerLow: function dangerLow() {
    return Io;
  },
  divider1: function divider1() {
    return dr;
  },
  divider2: function divider2() {
    return vr;
  },
  divider3: function divider3() {
    return xr;
  },
  grayHover: function grayHover() {
    return rr;
  },
  grayPressed: function grayPressed() {
    return ar;
  },
  inkText: function inkText() {
    return yr;
  },
  inkTextLow: function inkTextLow() {
    return gr;
  },
  onGrayOverlay100: function onGrayOverlay100() {
    return pr;
  },
  onGrayOverlay50: function onGrayOverlay50() {
    return lr;
  },
  onPrimary: function onPrimary() {
    return Co;
  },
  onPrimaryLowOverlay100: function onPrimaryLowOverlay100() {
    return sr;
  },
  onPrimaryLowOverlay200: function onPrimaryLowOverlay200() {
    return tr;
  },
  onPrimaryLowOverlay50: function onPrimaryLowOverlay50() {
    return cr;
  },
  onPrimaryOverlay200: function onPrimaryOverlay200() {
    return $o;
  },
  onPrimaryOverlay50: function onPrimaryOverlay50() {
    return Wo;
  },
  overlayDim: function overlayDim() {
    return Ho;
  },
  overlayLow: function overlayLow() {
    return Do;
  },
  paperAccent: function paperAccent() {
    return Vo;
  },
  paperBackground: function paperBackground() {
    return Uo;
  },
  paperContents: function paperContents() {
    return No;
  },
  paperDefault: function paperDefault() {
    return Qo;
  },
  paperDialog: function paperDialog() {
    return Ko;
  },
  paperFloating: function paperFloating() {
    return Mo;
  },
  paperSheet: function paperSheet() {
    return Jo;
  },
  primary: function primary() {
    return Ro;
  },
  primaryHover: function primaryHover() {
    return Xo;
  },
  primaryLow: function primaryLow() {
    return So;
  },
  primaryLowActive: function primaryLowActive() {
    return er;
  },
  primaryLowHover: function primaryLowHover() {
    return _o;
  },
  primaryLowPressed: function primaryLowPressed() {
    return or;
  },
  primaryPressed: function primaryPressed() {
    return Zo;
  },
  secondary: function secondary() {
    return To;
  },
  secondaryLow: function secondaryLow() {
    return Yo;
  },
  success: function success() {
    return Fo;
  },
  successLow: function successLow() {
    return jo;
  },
  textSelection: function textSelection() {
    return nr;
  },
  warning: function warning() {
    return qo;
  },
  warningLow: function warningLow() {
    return zo;
  }
});
var Co = "var(--seed-semantic-color-on-primary)",
    Do = "var(--seed-semantic-color-overlay-low)",
    Ho = "var(--seed-semantic-color-overlay-dim)",
    Wo = "var(--seed-semantic-color-on-primary-overlay-50)",
    $o = "var(--seed-semantic-color-on-primary-overlay-200)",
    Ro = "var(--seed-semantic-color-primary)",
    So = "var(--seed-semantic-color-primary-low)",
    To = "var(--seed-semantic-color-secondary)",
    Yo = "var(--seed-semantic-color-secondary-low)",
    Fo = "var(--seed-semantic-color-success)",
    jo = "var(--seed-semantic-color-success-low)",
    qo = "var(--seed-semantic-color-warning)",
    zo = "var(--seed-semantic-color-warning-low)",
    Eo = "var(--seed-semantic-color-danger)",
    Io = "var(--seed-semantic-color-danger-low)",
    Jo = "var(--seed-semantic-color-paper-sheet)",
    Ko = "var(--seed-semantic-color-paper-dialog)",
    Mo = "var(--seed-semantic-color-paper-floating)",
    No = "var(--seed-semantic-color-paper-contents)",
    Qo = "var(--seed-semantic-color-paper-default)",
    Uo = "var(--seed-semantic-color-paper-background)",
    Vo = "var(--seed-semantic-color-paper-accent)",
    Xo = "var(--seed-semantic-color-primary-hover)",
    Zo = "var(--seed-semantic-color-primary-pressed)",
    _o = "var(--seed-semantic-color-primary-low-hover)",
    er = "var(--seed-semantic-color-primary-low-active)",
    or = "var(--seed-semantic-color-primary-low-pressed)",
    rr = "var(--seed-semantic-color-gray-hover)",
    ar = "var(--seed-semantic-color-gray-pressed)",
    cr = "var(--seed-semantic-color-on-primary-low-overlay-50)",
    sr = "var(--seed-semantic-color-on-primary-low-overlay-100)",
    tr = "var(--seed-semantic-color-on-primary-low-overlay-200)",
    lr = "var(--seed-semantic-color-on-gray-overlay-50)",
    pr = "var(--seed-semantic-color-on-gray-overlay-100)",
    nr = "var(--seed-semantic-color-text-selection)",
    dr = "var(--seed-semantic-color-divider-1)",
    vr = "var(--seed-semantic-color-divider-2)",
    xr = "var(--seed-semantic-color-divider-3)",
    ir = "var(--seed-semantic-color-accent)",
    yr = "var(--seed-semantic-color-ink-text)",
    gr = "var(--seed-semantic-color-ink-text-low)";
export { l as vars };